<template>
  <div class="rgFsT">
    <form @submit.prevent="register">
      <label for="name">
        Nombre:
      </label>
      <input
          v-model="name"
          type="text"
          name="name"
          value>
      <label for="name">
        Telefono:
      </label>
      <input
          v-model="phone"
          type="text"
          name="phone"
          maxlength="9"
          value>
      <label for="email">
        Email:
      </label>
      <input v-model="email" type="email" name="email" value>

      <label for="password">
        Password:
      </label>
      <input v-model="password" type="password" name="password" value>

      <label for="rol">
        Rol:
      </label>
      <b-form-select
        id="rol"
          v-model="roleName"
          :options="roles"
          value-field="name"
          text-field="normalizedName"
      ></b-form-select>

      <button type="submit" name="button">
        Register
      </button>
        <router-link :to="{ name: 'Login'}">
          Ya tiene una cuenta? Login.
        </router-link>
    </form>
  </div>
</template>

<script>
import DataAccess from '@/Services/DataAccess.js'

export default {
  data () {
    return {
      name: '',
      email: '',
      password: '',
      customerID: '',
      roleName: '',
      phone: '',
      errors: null,
      roles: []
    }
  },
  created () {
    (async () => {
      await DataAccess.getData('/api/roles')
        .then(response => {
          this.roles = response.data
          this.loading = false
        })
        .catch(error => {
          console.log('ERROR: ', error)
        })
    })()
  },
  methods: {
    clearForm () {
      this.name = ''
      this.email = ''
      this.password = ''
      this.roleName = null
      this.phone = ''
    },
    register () {
      this.$store
        .dispatch('register', {
          nombreUsuario: this.name,
          email: this.email,
          password: this.password,
          telefonoUsuario: this.phone,
          roleName: this.roleName
        })
        .then(() => {
          // console.log('OK')
          this.clearForm()
          // this.$router.push({ name: 'Talleres' })
        })
        .catch(err => {
          this.errors = err.response.data
        })
    }
  }
}
</script>

<style scoped>

.rgFsT {
    color: #262626;
    color: rgba(var(--i1d,38,38,38),1);
    flex-grow: 1;
    justify-content: center;
    margin-top: 12px;
    max-width: 350px;
    width: 100%;
    margin: 40px auto;
}

  form {
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 15em;
    margin-bottom: 2em;
  }

  p{
    color: red;
  }

  input {
    display: block;
    box-sizing: border-box;
    width: 100%;
    height: 2.6em;
    padding: 0.5em;
    margin-bottom: 1em;
    font: 1em 'Avenir', Helvetica, sans-serif;
  }

  h1 {
    margin-top: 0;
  }
</style>
